/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApologizeState } from 'app/models/apologize';

export const apologizeForSelector = (state: any) => (state.apologize as ApologizeState)?.flags?.[0];
